export const Roles = {
  ADMIN: 'Admin',
  COLLABORATOR: 'Collaborator',
  VIEWER: 'Viewer'
}



// WEBPACK FOOTER //
// ./src/utils/Roles.js